import { StyleSheet } from 'react-native'
import { ThemedValues } from 'styles/themed'

export const ManagementDashboardComponentBuildingStyles = StyleSheet.create( {
	row: {
		width: '100%',
		gap: ThemedValues.stackSpace
	},
	rowTitle: {
		paddingBottom: 0
	}
})
